import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export function OfflineBanner() {
  const { t } = useTranslation('common');
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 bg-amber-900/40 text-amber-200 text-xs py-1 px-3"
      data-testid="offline-banner"
    >
      <WifiOff className="h-3.5 w-3.5" />
      {t('offline.banner')}
    </div>
  );
}
